var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 16.5459V0.545898H16.5V16.5459H0.5V20.5459H16.5V36.5459H20.5V20.5459H36.5V16.5459H20.5Z",
    fill: "#060709"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconDark);
export default __webpack_public_path__ + "static/media/plus-icon-dark.a90668df9349709b743eb012692fc971.svg";
export { ForwardRef as ReactComponent };